import React from "react";
import { Flex, Box } from "rebass";
import { useFormikContext } from "formik";
import Toggle from "react-toggle";
import { TextField } from "@shopify/polaris";
import { motion, AnimatePresence } from "framer-motion";

export default function PaymentGatewayTrigger() {
  const { values, setFieldValue } = useFormikContext();

  return (
    <AnimatePresence>
      <Flex flexDirection="column">
        <Flex justifyContent="flex-start" alignItems="center">
          <Box my={2} mx={3} display="flex" alignItems="center">
            <Toggle
              checked={values.paymentGatewayTriggerEnabled}
              onChange={(e) => {
                setFieldValue("paymentGatewayTriggerEnabled", e.target.checked);
              }}
            />
          </Box>
          <Box>Require ID verification for specific payment methods</Box>
        </Flex>
        {values.paymentGatewayTriggerEnabled && (
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -10 }}
          >
            <Box px={4} my={3} width={1}>
              <TextField
                name="payment-gateway-trigger"
                label="Payment Methods Requiring ID"
                monospaced
                helpText={
                  <>
                    Enter payment gateway names separated by commas. Orders paid
                    with these methods will require ID verification. You can
                    enter either the payment method slug (e.g., cod, bacs,
                    stripe) or the display name (e.g., Cash on Delivery, Credit
                    card). Matching is case-insensitive.
                  </>
                }
                value={(values.paymentGatewayTriggerGateways || []).join(",")}
                onChange={(value) => {
                  setFieldValue(
                    "paymentGatewayTriggerGateways",
                    value
                      .split(",")
                      .map((g) => g.trim())
                      .filter(Boolean)
                  );
                }}
              />
            </Box>
          </motion.div>
        )}
      </Flex>
    </AnimatePresence>
  );
}
